import React, { useState } from 'react';
import EyeSightTestSlider from '../EyesightTracker/EyesighttestSlider';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';
import Slider, { Range } from 'rc-slider';
import { TextField } from '@material-ui/core';
import 'rc-slider/assets/index.css';
import './EyesightTest.css';
import a1 from '../../assets/images/a1.png';
import a2 from '../../assets/images/a2.png';
import a3 from '../../assets/images/a3.png';
import a4 from '../../assets/images/a4.png';
import a5 from '../../assets/images/a5.png';
import a6 from '../../assets/images/a6.png';
// const images = [a1,a2,a3,a4,a5]
const EyeSightTest = (props) => {
    const { blogToken } = props;
    const [nextimg, setNextimg] = useState(0);

    var slider_img = document.querySelector('.slider-img');
    var images = [a1, a2, a3, a4, a5, a6];
    var i = 0;

    function prev() {
        setNextimg(nextimg - 1)
    }

    function next() {
        setNextimg(nextimg + 1)

    }

    // function setImg(){
    //     return slider_img.setAttribute('src', '../../assets/tracker-assets/' +images[i]);
    // }

    return (
        <div>
            <Navbar />

            <div className='container'>

                <div>
                    <div className="page-heading">
                        <div className="row">
                            <div className="col s12">
                                <h4>Color Blindness Test</h4>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="test-page">
                            <div className="col m6 s12">
                                <h6>Last question's answer : 45</h6>

                            </div>
                            <div className="col m6 s12">
                                <h6>Your current Score : 1/10</h6>

                            </div>

                            <div className="col m6 offset-m3 s12">
                                <div className="test-img">
                                    <div className="myslider">
                                        <div className="img-box">
                                            {images.map((img, index) => {
                                                if (index == nextimg)
                                                    return (
                                                        <img src={images[nextimg]} alt="image1" className="slider-img" />
                                                    )
                                            }
                                            )
                                            }
                                        </div>

                                        <div class="next-prev-btn">
                                            <button className="btn" onClick={prev}>prev</button>
                                            {nextimg < images.length &&
                                                <button className="btn" onClick={next}>next</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <h6>5 Question's Left</h6>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="es-test-slider-bg">
                <div className="container">
                                            <EyeSightTestSlider/>

                </div>
            </div>


            <Footer />
        </div>
    );
};

export default EyeSightTest;
